import { type ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@zaogig/auth';

interface RoleGuardProps {
  children: ReactNode;
  allowedRoles?: Array<'worker' | 'employer' | 'admin'>;
}

export function RoleGuard({ children, allowedRoles = ['employer', 'admin'] }: RoleGuardProps) {
  const { user, loading } = useAuth();

  if (loading) {
    return <div className="flex min-h-screen items-center justify-center text-slate-500">加载中...</div>;
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (!allowedRoles.includes(user.currentRole) && !user.roles.admin) {
    return (
      <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-slate-50">
        <div className="rounded-full bg-red-100 p-4">
          <span className="text-3xl">🚫</span>
        </div>
        <h2 className="text-xl font-bold text-slate-900">无权限访问</h2>
        <p className="text-sm text-slate-500">您当前身份为「{user.currentRole}」，无权访问企业管理后台</p>
        <a href="/" className="mt-2 rounded-xl bg-indigo-600 px-6 py-2 text-sm font-semibold text-white">
          返回首页
        </a>
      </div>
    );
  }

  return <>{children}</>;
}
